import React from 'react';
import PropTypes from 'prop-types';

const Modal_Conductores = ({ header, content, onClose, button1Text, button2Text, animate, sizeClass, onButton1Click, onButton2Click }) => (
  <div className="modal-overlay">
    <div className={`modal-content ${animate ? 'animate-modal' : ''} ${sizeClass}`}>
      <div className="modal-header">
        <h2>{header}</h2>
        <button className="close-modal" onClick={onClose}>x</button>
      </div>
      <hr className='hrReporte'/>
      <div className="modal-body">
        {content}
      </div>
    </div>
    {(button1Text || button2Text) && (
      <div className="modal-buttons">
        {button1Text && <button className="modal-button yellow" onClick={onButton1Click}>{button1Text}</button>}
        {button2Text && <button className="modal-button green" onClick={onButton2Click}>{button2Text}</button>}
      </div>
    )}
  </div>
);

Modal_Conductores.propTypes = {
  header: PropTypes.string.isRequired,
  content: PropTypes.node.isRequired,
  onClose: PropTypes.func.isRequired,
  button1Text: PropTypes.string,
  button2Text: PropTypes.string,
  animate: PropTypes.bool,
  sizeClass: PropTypes.string,
  onButton1Click: PropTypes.func,
  onButton2Click: PropTypes.func,
};

Modal_Conductores.defaultProps = {
  animate: true,
  sizeClass: 'ajustable',
  onButton1Click: () => {},
  onButton2Click: () => {},
};

export default Modal_Conductores;


// WEBPACK FOOTER //
// ./src/Components/Emp_Empresas/Modal_Conductores.js